import React from 'react';

const LoginSliderDotIcon = ({size = 10, color = "white", ...props}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={10} height={10} rx={5} fill={color}/>
    </svg>
);
export default LoginSliderDotIcon;